<template>
  <div>
    <v-data-table-virtual
      :headers="headers"
      :items="waitingList"
      height="100vh"
      item-value="name"
      fixed-header
    >
      <template v-slot:[`item.name`]="{ item }">
        <span>{{ item.first_name }} {{ item.last_name }}</span>
      </template>
      <template v-slot:[`item.enriched`]="{ item }">
        <v-icon v-if="item.hasOwnProperty('description')" color="accent"
          >mdi-check-circle</v-icon
        >
        <v-btn v-else variant="flat" size="small" @click="enrich(item)"
          >Enrich</v-btn
        >
      </template>
      <template v-slot:[`item.approved`]="{ item }">
        <v-switch
          v-model="item.approved"
          hide-details
          color="accent"
          @change="approve(item)"
        ></v-switch>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex" style="gap: 10px; align-items: center">
          <v-select
            v-model="item.status"
            :items="['onboarded', 'signed_up', 'approved']"
            @update:model-value="updateStatus(item)"
            variant="solo"
            hide-details
            density="compact"
          ></v-select>
          <v-dialog max-width="500">
            <template v-slot:activator="{ props: activatorProps }">
              <v-btn
                icon="mdi-eye"
                v-bind="activatorProps"
                variant="text"
                size="small"
              ></v-btn>
            </template>

            <template v-slot:default="{ isActive }">
              <v-card>
                <v-sheet
                  class="d-flex justify-center align-center py-2"
                  color="accent"
                  style="font-size: 10pt; font-weight: 600"
                >
                  Waiting list - signup
                </v-sheet>
                <div>
                  <v-text-field
                    v-model="item.first_name"
                    variant="solo"
                    hide-details
                    density="compact"
                    flat
                    label="First Name"
                    class="ma-2"
                  ></v-text-field>
                  <v-divider></v-divider>
                  <v-text-field
                    v-model="item.last_name"
                    variant="solo"
                    hide-details
                    density="compact"
                    flat
                    label="Last Name"
                    class="ma-2"
                  ></v-text-field>
                  <v-divider></v-divider>
                  <v-text-field
                    v-model="item.email"
                    variant="solo"
                    hide-details
                    density="compact"
                    flat
                    label="Email"
                    class="ma-2"
                  ></v-text-field>
                  <v-divider></v-divider>
                  <v-textarea
                    v-model="item.description"
                    variant="solo"
                    hide-details
                    density="compact"
                    flat
                    rows="10"
                    label="Description"
                    class="ma-2"
                  ></v-textarea>
                  <v-divider></v-divider>
                  <v-text-field
                    v-model="item.company_website"
                    variant="solo"
                    hide-details
                    density="compact"
                    flat
                    label="Company Website"
                    class="ma-2"
                  >
                    <template v-slot:append-inner>
                      <v-btn
                        icon="mdi-open-in-new"
                        @click="openWebsite(item.company_website)"
                        variant="text"
                        size="small"
                      ></v-btn>
                    </template>
                  </v-text-field>
                  <v-divider></v-divider>
                  <v-text-field
                    v-model="item.company_size"
                    variant="solo"
                    hide-details
                    density="compact"
                    flat
                    label="Company Size"
                    class="ma-2"
                  ></v-text-field>
                </div>

                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn text="Close" @click="isActive.value = false"></v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </div>
      </template>
    </v-data-table-virtual>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "@/firebase";

export default {
  name: "AdminWaiting",
  computed: {
    ...mapState({
      waitingList: (state) => state.admin.waitingList,
    }),
  },
  data() {
    return {
      headers: [
        {
          title: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          title: "Email",
          align: "start",
          sortable: false,
          value: "email",
        },
        {
          title: "Company Website",
          align: "start",
          sortable: false,
          value: "company_website",
        },
        {
          title: "Enriched",
          align: "start",
          sortable: false,
          value: "enriched",
        },
        {
          title: "Approved",
          align: "start",
          sortable: false,
          value: "approved",
        },
        { title: "Actions", align: "start", sortable: false, value: "actions" },
      ],
    };
  },
  methods: {
    openWebsite(url) {
      if (url && typeof url === "string") {
        let formattedUrl =
          url.startsWith("http://") || url.startsWith("https://")
            ? url
            : "https://" + url;
        window.open(formattedUrl, "_blank", "noopener,noreferrer");
      } else {
        this.$store.commit("setNotification", {
          show: true,
          text: "Invalid URL",
          type: "error",
          icon: "mdi-alert-circle",
        });
      }
    },
    async enrich(item) {
      console.log(item);
      const analyzeWebsite = httpsCallable(functions, "analyzeWebsite");
      const res = await analyzeWebsite({
        website: item.company_website,
        uid: item.uid,
      });
      console.log(res);
      this.$store.commit("setNotification", {
        show: true,
        text: "Enriched",
        type: "success",
        icon: "mdi-check-circle",
      });
      this.$store.dispatch("fetchAdminWaitingList");
    },
    async approve(item) {
      console.log(item);
      const approve = httpsCallable(functions, "approve");
      const res = await approve({
        uid: item.uid,
        value: item.approved,
      });
      console.log(res);

      this.$store.commit("setNotification", {
        show: true,
        text: "Approved",
        type: "success",
        icon: "mdi-check-circle",
      });
      this.$store.dispatch("fetchAdminWaitingList");
    },
    async updateStatus(item) {
      console.log(item);
      const washingtonRef = doc(db, "waiting_list", item.uid);

      await updateDoc(washingtonRef, {
        status: item.status,
      });
    },
  },
};
</script>

<style scoped></style>
